import React, { useEffect, useState } from 'react'
import { getUserData } from '../../adapters/users';

export default function UserProfile({ onClose, user }) {
  const [profile, setProfile] = useState({
    firstname: '',
    lastname: '',
    othername: '',
    occupation: '',
    religion: '',
    country: '',
    state: '',
  });

  useEffect(() => {
    setProfile(user.profile);
  }, [])

  
  return (
    <div onClick={() => {
      onClose();
    }} className="fixed z-50 animate__animated animate__fadeIn w-screen h-screen modal-dialog-bg-dark shadow-md md:px-8 px-4 left-0 top-0">
      <div className="relative w-full flex h-full justify-center items-center">
        <div className="lg:w-2/5 px-8 w-full bg-white py-8 rounded-xl">
           <div className="flex items-center justify-center pb-4 border-b border-gray-500">
              <div className="lg:h-36 h-24 w-24 lg:w-36 p-2 rounded-full ">
                <img src={user.avatar} alt="user avatar" className="h-full w-full rounded-full" />
              </div>
              <div className="text-start ml-4 lg:ml-8">
                <h4 className="text-xl font-semibold">{user.name}</h4>
                <a href={`mailto:${user.email}`} className="text-xs text-blue-900 font-semibold">{user.email}</a> <br />
                {/* <a href={`tel:${profile.profile.phone}`} className="text-xs text-blue-900 font-semibold">{profile.profile.phone}</a> */}
                </div>
            </div>

            <div className="mt-4">
              <ul>
                <li className="mb-3">
                  <div className="flex justify-between items-center text-xs">
                      <span className="font-fira font-semibold">
                        Firstname
                      </span>

                      <span className="font-fira font-semibold">
                        { profile.firstname}
                      </span>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="flex justify-between items-center text-xs">
                      <span className="font-fira font-semibold">
                        Lastname
                      </span>

                      <span className="font-fira font-semibold">
                        {profile.lastname}
                      </span>
                  </div>
                </li>
                <li className="mb-3">
                  <div className="flex justify-between items-center text-xs">
                      <span className="font-fira font-semibold">
                        Country
                      </span>

                      <span className="font-fira font-semibold">
                        {profile.country}
                      </span>
                  </div>
                </li>

                <li className="mb-3">
                  <div className="flex justify-between items-center text-xs">
                      <span className="font-fira font-semibold">
                        State
                      </span>

                      <span className="font-fira font-semibold">
                        {profile.state}
                      </span>
                  </div>
                </li>

                <li className="mb-3">
                  <div className="flex justify-between items-center text-xs">
                    <span className="font-fira font-semibold">
                      Religion
                    </span>

                    <span className="font-fira font-semibold">
                    {profile.religion}
                    </span>
                  </div>
                </li>

              <li className="mb-3">
                <div className="flex justify-between items-center text-xs">
                  <span className="font-fira font-semibold">
                    Occupation
                  </span>

                  <span className="font-fira font-semibold">
                    {profile.occupation}
                  </span>
                </div>
              </li>
              </ul>
            </div>
        </div>

        <button onClick={onClose} className="absolute top-4 right-4 text-white hover:text-red-600">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
            <path fillRule="evenodd" d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
    </div>
  )
}
